export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_DRAWER = "SET_OPEN_DRAWER";
export const SET_EXT_CUSTOM_COLUMN = "SET_EXT_CUSTOM_COLUMN";
export const SET_TEMP_SELECTIONS = "SET_TEMP_SELECTIONS";

export const GET_EXT_CUSTOM_COLUMNS = "GET_EXT_CUSTOM_COLUMNS";
export const GET_EXT_CUSTOM_COLUMNS_SUCCESS = "GET_EXT_CUSTOM_COLUMNS_SUCCESS";
export const GET_EXT_CUSTOM_COLUMNS_FAILURE = "GET_EXT_CUSTOM_COLUMNS_FAILURE";

export const GET_EXT_CUSTOM_COLUMN = "GET_EXT_CUSTOM_COLUMN";
export const GET_EXT_CUSTOM_COLUMN_SUCCESS = "GET_EXT_CUSTOM_COLUMN_SUCCESS";
export const GET_EXT_CUSTOM_COLUMN_FAILURE = "GET_EXT_CUSTOM_COLUMN_FAILURE";

export const CREATE_EXT_CUSTOM_COLUMN = "CREATE_EXT_CUSTOM_COLUMN";
export const CREATE_EXT_CUSTOM_COLUMN_SUCCESS = "CREATE_EXT_CUSTOM_COLUMN_SUCCESS";
export const CREATE_EXT_CUSTOM_COLUMN_FAILURE = "CREATE_EXT_CUSTOM_COLUMN_FAILURE";

export const UPDATE_EXT_CUSTOM_COLUMN = "UPDATE_EXT_CUSTOM_COLUMN";
export const UPDATE_EXT_CUSTOM_COLUMN_SUCCESS = "UPDATE_EXT_CUSTOM_COLUMN_SUCCESS";
export const UPDATE_EXT_CUSTOM_COLUMN_FAILURE = "UPDATE_EXT_CUSTOM_COLUMN_FAILURE";

export const DELETE_EXT_CUSTOM_COLUMN = "DELETE_EXT_CUSTOM_COLUMN";
export const DELETE_EXT_CUSTOM_COLUMN_SUCCESS = "DELETE_EXT_CUSTOM_COLUMN_SUCCESS";
export const DELETE_EXT_CUSTOM_COLUMN_FAILURE = "DELETE_EXT_CUSTOM_COLUMN_FAILURE";

export const UPDATE_EXT_CUSTOM_COLUMNS_ORDER = "UPDATE_EXT_CUSTOM_COLUMNS_ORDER";
export const UPDATE_EXT_CUSTOM_COLUMNS_ORDER_SUCCESS = "UPDATE_EXT_CUSTOM_COLUMNS_ORDER_SUCCESS";
export const UPDATE_EXT_CUSTOM_COLUMNS_ORDER_FAILURE = "UPDATE_EXT_CUSTOM_COLUMNS_ORDER_FAILURE";

export const ATTACH_EXT_CUSTOM_COLUMN = "ATTACH_EXT_CUSTOM_COLUMN";
export const ATTACH_EXT_CUSTOM_COLUMN_SUCCESS = "ATTACH_EXT_CUSTOM_COLUMN_SUCCESS";
export const ATTACH_EXT_CUSTOM_COLUMN_FAILURE = "ATTACH_EXT_CUSTOM_COLUMN_FAILURE";

export const DETACH_EXT_CUSTOM_COLUMN = "DETACH_EXT_CUSTOM_COLUMN";
export const DETACH_EXT_CUSTOM_COLUMN_SUCCESS = "DETACH_EXT_CUSTOM_COLUMN_SUCCESS";
export const DETACH_EXT_CUSTOM_COLUMN_FAILURE = "DETACH_EXT_CUSTOM_COLUMN_FAILURE";

export const RESET_CUSTOM_COLUMN_FORM = "RESET_CUSTOM_COLUMN_FORM";